module.exports = __webpack_public_path__ + "img/DE06264.301bd709.png";